import React from 'react';

import { Area, Box, Modal } from '@ublend-npm/aulaui-core';

import InviteParticipants from './InviteParticipants';

interface InviteParticipantsModalProps {
  open: boolean;
  onClose: () => void;
  conversationId?: string;
}

const InviteParticipantsModal = ({
  open,
  onClose,
  conversationId,
}: InviteParticipantsModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{ width: { xs: '341px', sm: '407px', md: '562px', lg: '760px' } }}
      >
        <Area rounded>
          <InviteParticipants
            onClose={onClose}
            conversationId={conversationId}
          />
        </Area>
      </Box>
    </Modal>
  );
};

export default InviteParticipantsModal;
